import { Modal, Stack, Text, Group, Title } from '@mantine/core';
import { ActionButton } from './ActionButton';

interface ConfirmationModalProps {
  opened: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmAriaLabel?: string;
  cancelAriaLabel?: string;
  onClose?: () => void;
}

export function ConfirmationModal({
  opened,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel,
  cancelLabel = 'Cancel',
  confirmAriaLabel,
  cancelAriaLabel,
  onClose
}: Readonly<ConfirmationModalProps>) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      handleClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      closeButtonProps={{ tabIndex: -1 }}
      closeOnClickOutside={true}
      title={
        <Title order={3} sx={(theme) => ({
          color: theme.colorScheme === 'dark' ? theme.colors.red[4] : theme.colors.red[7],
          marginBottom: theme.spacing.xs
        })}>
          {title}
        </Title>
      }
      centered
      role="dialog"
      aria-label={title}
      styles={(theme) => ({
        header: {
          marginBottom: 0,
          paddingBottom: 0
        }
      })}
    >
      <Stack>
        <Text size="sm">{message}</Text>
        <Group position="apart">
          <ActionButton
            onClick={handleCancel}
            label={cancelLabel}
            ariaLabel={cancelAriaLabel ?? cancelLabel}
            actionType="secondary"
          />
          <ActionButton
            onClick={handleConfirm}
            label={confirmLabel}
            ariaLabel={confirmAriaLabel ?? confirmLabel}
            actionType="primary"
          />
        </Group>
      </Stack>
    </Modal>
  );
} 